import { fetchUserReport } from "../../../api/home/userReport.service"
import {FETCH_USER_REPORT } from "../actionTypes"

const Request = ()=>({type: FETCH_USER_REPORT.REQUEST})
const Failure = (error)=>({type: FETCH_USER_REPORT.FAILURE, error})
const Success = (obj)=>({type: FETCH_USER_REPORT.SUCCESS, obj})


export const getUserReport = (option)=>{
    return (dispatch, getState)=>{        
        dispatch(Request())
        return fetchUserReport(option)  
        .then(response => {            
            dispatch(Success(response))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(Failure(error?.message))
            return Promise.resolve(false)
        })
    }
}